<template>
    <ShowTemplate
        :model="product"
        :owners="[product.organization].filter((owner) => owner != null)"
        :descriptionTabs="descriptionTabs"
        :access="product.access"
        :can="permissions"
        :rolePanels="rolePanels"
        :availableEmotions="availableEmotions"
        :relations="relations"
        :statistics="statistics"
    />
</template>

<script>
import ShowTemplate from '@/Templates/ShowTemplate.vue'

export default {
    components: {
        ShowTemplate,
    },

    props: {
        product: {
            type: Object,
            required: true,
        },
        permissions: {
            type: Object,
            required: true,
        },
        rolePanels: {
            type: Array,
            required: true,
        },
        availableEmotions: {
            type: Array,
            required: true,
        },
        statistics: {
            type: Object,
            default: {},
        },
        resources: {
            type: Object,
            default: {},
        },
        events: {
            type: Object,
            default: {},
        },
    },

    computed: {
        descriptionTabs() {
            return [
                {
                    id: 'description',
                    name: this.$lang.get('Description'),
                    content: this.product.description,
                },
            ].filter((tab) => !!tab.content)
        },
        relations() {
            return [this.resources, this.events].filter(
                (relation) => Object.keys(relation).length > 0
            )
        },
    },
}
</script>
